import { useMemo, useCallback } from 'react';

import { useFormTemplatesByUidMap } from './useEntitiesMap';
import { CacaForm } from '../types';

// with APS endpoints, we no longer have access to template name on Form object, we need to associate it from templates data
const useTemplateName = (form: CacaForm) => {
  const { data: formTemplatesMap, loading: isLoadingFormTemplatesMap } =
    useFormTemplatesByUidMap();
  const getTemplateName = useCallback(
    (form: CacaForm) => {
      if (isLoadingFormTemplatesMap) {
        return '';
      }
      if (!formTemplatesMap) {
        return form.report_type.name;
      }
      return formTemplatesMap[form.type]?.name;
    },
    [formTemplatesMap, isLoadingFormTemplatesMap],
  );
  const templateName = useMemo(() => {
    if (!form) {
      return '';
    }
    return getTemplateName(form);
  }, [form, getTemplateName]);
  return { templateName, getTemplateName };
};

export default useTemplateName;
